import script from "./submitRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./submitRecords.vue?vue&type=script&setup=true&lang=js"

import "./submitRecords.vue?vue&type=style&index=0&id=4bb52582&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb52582"]])

export default __exports__